<script lang="ts">
    import { cn } from '$lib/utils/cn';

    import qs from 'query-string';

    import { getParamsFromUrl, stripCropParams } from '../_utils/helpers';

    import type { HeaderImageContent } from '$lib/types/Components/HeaderImage/HeaderImageContent';

    export let content: HeaderImageContent;
    export let onClick: (event: MouseEvent | TouchEvent) => void;

    const sizeMap: Record<
        'small' | 'medium' | 'large' | 'xLarge',
        { class: string; height: number }
    > = {
        small: {
            class: 'fun-h-8',
            height: 32,
        },
        medium: {
            class: 'fun-h-10',
            height: 40,
        },
        large: {
            class: 'fun-h-12',
            height: 48,
        },
        xLarge: {
            class: 'fun-h-16',
            height: 64,
        },
    };

    const imageClasses: string = cn(
        'fun-inline-block',
        sizeMap[content.size].class ?? sizeMap.medium.class,
    );

    const existingParams = getParamsFromUrl(content.src) ?? {};
    const isCropped = existingParams?.crop === 'focalpoint';

    const imgixParams = {
        ...existingParams,
        q: 80,
        dpr: 2,
        fit: 'crop',
        auto: ['format', 'compress'],
        ...(isCropped
            ? {}
            : {
                  h: sizeMap[content.size].height ?? sizeMap.medium.height,
                  w: undefined,
              }),
    };

    const newQueryString = qs.stringify(imgixParams, { arrayFormat: 'comma' });
    const updatedSrc = content.src.split('?')[0] + '?' + newQueryString;

    const isGif = updatedSrc.includes('.gif');

    const adjustedSrc = isGif ? stripCropParams(updatedSrc) : updatedSrc;
</script>

<div class="fun-border-box fun-w-full fun-p-2">
    <button on:click={onClick}>
        <img class={imageClasses} src={adjustedSrc} alt="Logo" />
    </button>
</div>
